import React, { useState } from 'react'
import { useHistory } from 'react-router-dom';
import right_arrow from "./resources_catalog/icons/ico_right_arrow.svg";
const CatalogHeaderMenu = () => {

  const history = useHistory();
  const [displayflg, setDisplayFlg] = useState(false);

  const onClickMenu = () => {
    setDisplayFlg(!displayflg);
  }

  return (
    <div>
      <div className={displayflg ? 'szh-menu-button szh-menu-button--open' : 'szh-menu-button'} onClick={onClickMenu}>
        <div className={displayflg ? "catalogHeaderMenu" : "hiddenItem"} >
          <div className="catalogHeaderMenuButtonSp" onClick={() => history.push("/rtcc/catalog/hotelLineupJp")}>
            <p >RTCC宿泊(国内・海外手配旅行)<br />ラインナップ</p>
            <img src={right_arrow} alt="" />
          </div>
          <div className="catalogHeaderMenuButtonSp" onClick={() => history.push("/rtcc/catalog/hotelLineupOverseas")}>
            <p>RTCCハワイ(海外募集型企画旅行)<br />ラインナップ</p>
            <img src={right_arrow} alt="" />
          </div>
          <div className="catalogHeaderMenuButtonSp" onClick={() => history.push("/rtcc/catalog/aboutService")}>
            <p>RTCC旅行業サービスとは</p>
            <img src={right_arrow} alt="" />
          </div>
          <div className="catalogHeaderMenuButtonSp" onClick={() => history.push("/rtcc/catalog/howToReserveJp")}>
            <p>RTCC宿泊(国内・海外手配旅行)<br />予約方法</p>
            <img src={right_arrow} alt="" />
          </div>
          <div className="catalogHeaderMenuButtonSp" onClick={() => history.push("/rtcc/catalog/howToReserveOverseas")}>
            <p>RTCCハワイ(海外募集型企画旅行)<br />予約方法</p>
            <img src={right_arrow} alt="" />
          </div>
          <div className="catalogHeaderMenuButtonSp" onClick={() => history.push("/rtcc/catalog/question")}>
            <p>よくあるご質問</p>
            <img src={right_arrow} alt="" />
          </div>
        </div>
        <div className={displayflg ? "catalogHeaderMenuBack": "hiddenItem"}></div>
      </div>
    </div>
  );
}

export default CatalogHeaderMenu;